import { Search } from '@montel/montelpro-shared-components-v2';
import styled, { css } from 'styled-components';

export const FilterGroup = styled.nav<{
	$treatGroupsAsSingle?: boolean;
}>`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: ${({ theme }) => theme.spacing.xs};
`;

export const StyledSearch = styled(Search)`
	height: ${({ theme }) => theme.spacing.xl};
`;

export const FilterButton = styled.button<{
	$checked: boolean;
	$groupCanBeCleared?: boolean;
	[otherProps: string]: any;
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	transition: linear 75ms;
	box-sizing: border-box;
	font-weight: 600;
	width: 100%;

	${({ $checked, $groupCanBeCleared = false, theme }) => {
		const {
			borderBrand,
			bgBrand,
			element,
			bgWarning,
			textDefault,
			textSubtle,
		} = theme.colors;
		const { spacing, borderRadii } = theme;
		const borderColor = $checked ? bgBrand : borderBrand;
		const backgroundColor = $checked ? bgBrand : 'transparent';
		return css`
			color: ${$checked ? textDefault : textSubtle};
			height: ${spacing.xl};
			cursor: ${$groupCanBeCleared
				? 'pointer'
				: $checked
				? 'default'
				: 'pointer'};
			pointer-events: ${$groupCanBeCleared
				? 'inherit'
				: $checked
				? 'none'
				: 'inherit'};
			padding: ${spacing.lg} ${spacing.lg};
			border: 1px solid ${borderColor};
			border-radius: ${borderRadii.base};
			background-color: ${backgroundColor};
			height: ${spacing.xl};
			&:hover {
				background-color: ${element};
			}
			&:focus-visible {
				outline: 2px solid ${bgWarning};
			}
		`;
	}};
`;
